import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import intl from "react-intl-universal";

import FormLabels from "../../../library/custom/formLabel/FormLabels";
import RadioButton from "../../../library/custom/radioButton/RadioButton";
import Button from "../../../library/custom/button/Button";
import Witness from "../../../library/custom/witness/Witness";
import CreateAction from "../../../library/custom/createAction/CreateAction";
import FormDropZone from "../../../library/dropZone/FormDropZoneIncident";
import TextEditor from "../../../library/custom/textEditor/TextEditor";
import SelectMenu from "../../../library/custom/selectMenu/SelectMenu";
import MultiSelectBox from "../../../library/custom/selectMenu/MultiSelectBox";
import SearchAutoComplete from "../../../library/custom/searchAutoComplete/SearchAutoComplete";
import { InputField } from "../../../library/custom/textBox/InputField";
import { INCIDENT_STATUS } from "../../../constant/constant";
import { isEmptyHtmlContent, sortAlphabetically } from "../../../utils/helper";
import { useDebounce } from "../../../utils/useDebounceSearch";

const PropertyDamageForm = ({
  incident,
  caseData,
  onSubmit,
  searchOption,
  propertyDamageData,
  incidentId,
  caseId,
  fileUploadData,
  uploadFile,
  editMode,
  isLoading,
  searchAllUsers,
  allUsers,
  fileError,
  countError,
  isDraft,
  isDraftforaction,
  propertyDamageDataStatus,
  assetOption,
  searchAsset,
}) => {
  const userId = localStorage.getItem("userId");
  const { whosePropertyDamaged, typeOfDamage, propertyDamageContributingFactors } =
    incident;

  const sortedWhoseProperty = sortAlphabetically(whosePropertyDamaged ?? []);
  const sortedTypeOfDamage = sortAlphabetically(typeOfDamage ?? []);
  const sortedContributingFactors = sortAlphabetically(
    propertyDamageContributingFactors ?? []
  );

  const intialState = {
    projectId: null,
    locationOfDamage: "",
    whosePropertyId: "",
    typeOfDamage: [],
    describeDamage: "",
    contributingFactors: [],
    estimatedCost: "",
    actionsTaken: "",
    isPoliceReportFiled: false,
    policeReportNumber: "",
    addDetails: "",
  };
  const [formValue, setFormValue] = useState(intialState);
  const [projectNameValue, setProjectNameValue] = useState("");

  const [errorState, setErrorState] = useState({
    locationOfDamage: false,
    whosePropertyId: false,
    typeOfDamage: false,
    describeDamage: false,
    contributingFactors: false,
    actionsTaken: false,
    policeReportNumber: false,
  });

  // ---- Project type-ahead (this form has no employee picker, so the project is searched directly) ----
  const [assetSearchValue, setAssetSearchValue] = useState("");
  const debouncedAssetSearch = useDebounce(assetSearchValue, 500);
  useEffect(() => {
    if (!debouncedAssetSearch) return;
    searchAsset(debouncedAssetSearch, 1);
  }, [debouncedAssetSearch]);

  const onSelectSearchProject = (event, value) => {
    setProjectNameValue({ key: value?.key ?? "", value: value?.value ?? "" });
    setFormValue((prev) => ({ ...prev, projectId: value?.key ?? null }));
  };

  // ---- Witness ----
  const [witnessType, setWitnessType] = useState(false);
  const newWitness = () => ({
    id: Date.now() + Math.floor(Math.random() * 100),
    witnessName: "",
    employerName: "",
    jobTitle: "",
    statement: "",
    signature: "",
    files: [],
    isErrorWitnessName: false,
    isErrorStatement: false,
    errorWitnessNameMsg: "",
    errorStatementMsg: "",
  });
  const [witnessList, setWitnessList] = useState([newWitness()]);

  const handleOnclickWitness = () => {
    if (witnessList.length < 4) setWitnessList([...witnessList, newWitness()]);
  };
  const cancelWitnessList = (id) =>
    setWitnessList(witnessList.filter((witness) => witness.id !== id));

  const handleOnChangeWitnessForm = (event, data) => {
    const elementId = event.target.id;
    const value = event.target.value;
    const updatedWitnessList = [...witnessList];
    updatedWitnessList.forEach((witnessLists) => {
      if (witnessLists.id === data.id) {
        if (elementId === "name") witnessLists.witnessName = value;
        else if (elementId === "jobTitle") witnessLists.jobTitle = value;
        else if (elementId === "statement") witnessLists.statement = value;
        else if (elementId === "employerName") witnessLists.employerName = value;
        else if (elementId === "uploadMedia") witnessLists.files = value;
      }
    });
    setWitnessList(updatedWitnessList);
  };

  const [filesData, setFilesData] = useState("");
  const [witnessData, setWitnessData] = useState("");
  const witnessFileUpload = (files, single) => {
    setFilesData(files);
    setWitnessData(single);
  };
  useEffect(() => {
    const updatedWitnessList = [...witnessList];
    updatedWitnessList.forEach((witnessLists) => {
      if (witnessLists.id === witnessData.id) witnessLists.files = filesData;
    });
    setWitnessList(updatedWitnessList);
  }, [filesData]);

  const handleDeleteWitnessImage = (urls, singleWitness) => {
    const cloneWitness = [...witnessList];
    cloneWitness.forEach((singleWitn) => {
      if (singleWitn.id === singleWitness.id) {
        singleWitn.files = singleWitn.files
          .split("|")
          .filter((url) => url !== urls)
          .join("|");
      }
    });
    setWitnessList(cloneWitness);
  };

  // ---- Action items ----
  const [actionList, setActionlist] = useState([
    {
      assignedPartyName: "",
      file: [],
      isFileAdded: false,
      selectedFileName: "",
      description: "",
      id: Date.now() + Math.floor(Math.random() * 100),
      isCompleted: false,
      fileId: null,
      isError: false,
      isFileError: false,
      isNew: true,
      isErrorDescription: false,
      assignedPartyId: null,
    },
  ]);
  const [newActionIds, setNewActionIds] = useState(new Set());

  useEffect(() => {
    if (editMode && isDraftforaction !== "1" && Array.isArray(actionList)) {
      const emptyIds = actionList
        .filter((a) => !a?.description && !a?.assignedPartyName)
        .map((a) => a.id);
      if (emptyIds.length > 0) {
        setNewActionIds((prev) => {
          const updated = new Set(prev);
          emptyIds.forEach((id) => updated.add(id));
          return updated;
        });
      }
    }
  }, [editMode, isDraftforaction, actionList]);

  const handleChangeCreateActionDesc = (value, data) => {
    const updatedActionList = actionList;
    updatedActionList.forEach((singleValue) => {
      if (singleValue.id === data.id) singleValue.description = value;
    });
    setActionlist(updatedActionList);
  };

  const handleAddAssigneeCta = (event, users, data) => {
    const updatedActionList = actionList;
    updatedActionList.forEach((singleValue) => {
      if (singleValue.id === data.id) {
        singleValue.assignedPartyName = users?.value || {};
        singleValue.assignedPartyId = users?.key || 0;
        singleValue.isError = false;
        singleValue.isFileError = false;
      }
    });
    setActionlist(updatedActionList);
  };

  const [selectedData, setSelectedData] = useState([]);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [selectedFileUploaded, setSelectedFileUploaded] = useState([]);

  const handleUploadFileMethod = (fileUploaded, fileName, data) => {
    setSelectedData(data);
    setSelectedFileName(fileName);
    setSelectedFileUploaded(fileUploaded);
    uploadFile(fileUploaded);
  };

  useEffect(() => {
    if (fileUploadData) {
      const updatedActionList = [...actionList];
      updatedActionList.forEach((actionLists) => {
        if (actionLists.id === selectedData.id) {
          actionLists.file = selectedFileUploaded;
          actionLists.isFileAdded = true;
          actionLists.fileId = [fileUploadData?.files[0].id];
          actionLists.selectedFileName = selectedFileName;
          actionLists.isFileError = false;
        }
      });
      setActionlist(updatedActionList);
    }
  }, [fileUploadData]);

  useEffect(() => {
    if (countError) {
      const updatedActionList = [...actionList];
      updatedActionList.forEach((actionLists) => {
        if (actionLists.id === selectedData.id) actionLists.isFileError = true;
      });
      setActionlist(updatedActionList);
    }
  }, [countError]);

  const handleCreateActionCancelCta = (data) => {
    const newActionList = actionList.filter(
      (singleAction) => data.id !== singleAction.id
    );
    if (newActionIds.has(data.id)) {
      setNewActionIds((prev) => {
        const updated = new Set(prev);
        updated.delete(data.id);
        return updated;
      });
    }
    setActionlist(newActionList);
  };

  const removeActionImage = (singleAction) => {
    const actionListClone = [...actionList];
    actionListClone.forEach((Actionlist) => {
      if (Actionlist?.id === singleAction?.id) {
        Actionlist.fileId = null;
        Actionlist.file = [];
        Actionlist.isFileAdded = false;
        Actionlist.selectedFileName = "";
        Actionlist.isFileError = false;
      }
    });
    setActionlist(actionListClone);
  };

  const handleOnclickAddAction = () => {
    if (actionList.length < 4) {
      const newId = Date.now() + Math.floor(Math.random() * 100);
      setNewActionIds((prev) => new Set(prev).add(newId));
      setActionlist([
        ...actionList,
        {
          assignedPartyName: "",
          file: null,
          selectedFileName: "",
          description: "",
          id: newId,
          isCompleted: false,
          isError: false,
          isFileError: false,
          isNew: true,
        },
      ]);
    }
  };

  // ---- Form-level file upload ----
  const [pdFiless, setPdFiless] = useState([]);
  const [pdAddPhoto, setPdAddPhoto] = useState("");
  const [pdFileIds, setPdFileIds] = useState([]);

  const handlePdFileChange = (photos, fileIds) => {
    setPdAddPhoto(photos || "");
    const validFileIds = Array.isArray(fileIds)
      ? fileIds.filter(
          (id) => id !== null && id !== undefined && id !== "" && id !== "null"
        )
      : [];
    setPdFileIds(validFileIds);
  };
  const handleDeletePdFile = () => {
    // FormDropZone handles deletion internally and re-invokes handleFileChange.
  };

  // ---- Rehydrate on edit / draft ----
  useEffect(() => {
    if (!propertyDamageData || !incidentId) return;

    const {
      propertyDamage,
      witness,
      actions,
      additionalDetails,
      isWitness,
      files,
      fileIds,
    } = propertyDamageData;

    setWitnessType(isWitness);

    if (files?.length > 0) {
      setPdAddPhoto(files.map((file) => file.value).join("|"));
      setPdFileIds(
        files
          .map((file) => file.key)
          .filter((id) => id !== null && id !== undefined && id !== "")
      );
      setPdFiless(
        files.map((file) => ({
          id: file.key,
          fileName: file.value.split("/").pop(),
          fileUrl: file.value,
        }))
      );
    } else if (fileIds?.length > 0) {
      setPdFileIds(
        fileIds.filter((id) => id !== null && id !== undefined && id !== "")
      );
    }

    if (witness?.length > 0) {
      setWitnessList(
        witness.map((item) => ({
          employerName: item.employerName,
          witnessName: item.witnessName,
          jobTitle: item.jobTitle,
          statement: item.statement,
          files: item.files,
          id: item.witnessId,
          isErrorWitnessName: false,
          isErrorStatement: false,
          errorWitnessNameMsg: "",
          errorStatementMsg: "",
        }))
      );
    }

    if (actions?.length > 0) {
      setActionlist(
        actions.map((item) => ({
          isFileAdded: item.isFileAdded,
          files: item.files,
          description: item.description,
          assignedPartyName: item.assignedPartyName,
          assignedPartyId: item.assignedPartyId,
          id: item.actionId,
          fileId: item?.files?.map((f) => f.fileId),
          status: item?.status,
        }))
      );
    }

    setFormValue({
      ...intialState,
      addDetails: additionalDetails ?? "",
      projectId: propertyDamage?.projectId ?? null,
      locationOfDamage: propertyDamage?.locationOfDamage ?? "",
      whosePropertyId: propertyDamage?.whosePropertyId ?? "",
      // The multi-selects round-trip as display values, matching MultiSelectBox.
      typeOfDamage:
        propertyDamage?.typeOfDamageKeyValue?.map((item) => item.value) ?? [],
      contributingFactors:
        propertyDamage?.contributingFactorsKeyValue?.map(
          (item) => item.value
        ) ?? [],
      describeDamage: propertyDamage?.describeDamage ?? "",
      estimatedCost: propertyDamage?.estimatedCost ?? "",
      actionsTaken: propertyDamage?.actionsTaken ?? "",
      isPoliceReportFiled: propertyDamage?.isPoliceReportFiled ?? false,
      policeReportNumber: propertyDamage?.policeReportNumber ?? "",
    });

    if (propertyDamage?.projectId) {
      setProjectNameValue({
        key: propertyDamage.projectId,
        value: propertyDamage.projectName ?? "",
      });
    }
  }, [propertyDamageData, propertyDamageDataStatus]);

  const onChangeField = (e) => {
    const { id, value } = e.target;
    setFormValue((prev) => ({ ...prev, [id]: value }));
    setErrorState((prev) => ({ ...prev, [id]: false }));
  };

  const onChangeEstimatedCost = (e) => {
    const next = e.target.value;
    if (next === "" || /^\d*\.?\d{0,2}$/.test(next)) {
      setFormValue((prev) => ({ ...prev, estimatedCost: next }));
    }
  };

  const onChangeSelect = (e) => {
    const { name, value } = e.target;
    setFormValue((prev) => ({ ...prev, [name]: value }));
    setErrorState((prev) => ({ ...prev, [name]: false }));
  };

  // Toggling the radio must not discard anything else on the form; only the
  // dependent field is cleared, and only when the answer becomes "No".
  const onChangePoliceReport = (value) => {
    setFormValue((prev) => ({
      ...prev,
      isPoliceReportFiled: value,
      policeReportNumber: value ? prev.policeReportNumber : "",
    }));
    setErrorState((prev) => ({ ...prev, policeReportNumber: false }));
  };

  function findValueMultipleSelect(arrrayofObject, selectedArray) {
    const valueArray = [];
    (arrrayofObject ?? []).forEach((data) => {
      if ((selectedArray ?? []).indexOf(data.value) >= 0 && data.isActive) {
        valueArray.push(data.key);
      }
    });
    return valueArray;
  }

  function mappedData(isSaveAsDraft) {
    let errors = false;

    if (!isSaveAsDraft) {
      const nextErrors = {
        locationOfDamage: false,
        whosePropertyId: false,
        typeOfDamage: false,
        describeDamage: false,
        contributingFactors: false,
        actionsTaken: false,
        policeReportNumber: false,
      };

      if (!formValue.locationOfDamage?.trim()) {
        nextErrors.locationOfDamage = true;
        errors = true;
      }
      if (!formValue.whosePropertyId) {
        nextErrors.whosePropertyId = true;
        errors = true;
      }
      if (!formValue.typeOfDamage || formValue.typeOfDamage.length === 0) {
        nextErrors.typeOfDamage = true;
        errors = true;
      }
      if (
        !formValue.describeDamage ||
        isEmptyHtmlContent(formValue.describeDamage)
      ) {
        nextErrors.describeDamage = true;
        errors = true;
      }
      if (
        !formValue.contributingFactors ||
        formValue.contributingFactors.length === 0
      ) {
        nextErrors.contributingFactors = true;
        errors = true;
      }
      if (
        !formValue.actionsTaken ||
        isEmptyHtmlContent(formValue.actionsTaken)
      ) {
        nextErrors.actionsTaken = true;
        errors = true;
      }
      if (
        formValue.isPoliceReportFiled === true &&
        !formValue.policeReportNumber?.trim()
      ) {
        nextErrors.policeReportNumber = true;
        errors = true;
      }
      setErrorState(nextErrors);

      const updatedwitnessList = [...witnessList];
      if (updatedwitnessList.length > 0 && witnessType) {
        updatedwitnessList.forEach((data) => {
          if (data.witnessName.trim() === "") {
            data.witnessName = "";
            data.isErrorWitnessName = true;
            data.errorWitnessNameMsg = "Please enter this required field";
            errors = true;
          }
          if (data.statement.trim() === "") {
            data.statement = "";
            data.isErrorStatement = true;
            data.errorStatementMsg = "Please enter this required field";
            errors = true;
          }
        });
      }
      setWitnessList(updatedwitnessList);

      const cloneActionList = actionList.map((items) => {
        const hasDescription =
          items.description && !isEmptyHtmlContent(items.description);
        const hasAssignee = !!items.assignedPartyId;
        const updatedItem = { ...items };
        updatedItem.isErrorDescription = false;
        updatedItem.isError = false;
        if (hasDescription && !hasAssignee) {
          updatedItem.isError = true;
          errors = true;
        }
        if (!hasDescription && hasAssignee) {
          updatedItem.isErrorDescription = true;
          errors = true;
        }
        return updatedItem;
      });
      setActionlist(cloneActionList);

      if (errors) {
        window.scrollTo({ top: 300, left: 0, behavior: "smooth" });
        return false;
      }
    }

    const actionListData = [];
    actionList.forEach((data) => {
      const hasDescription =
        data.description && !isEmptyHtmlContent(data.description);
      const hasAssignee = !!data.assignedPartyId;
      if (!hasDescription && !hasAssignee) return;

      const action = {
        assignedPartyId: data?.assignedPartyId
          ? parseInt(data.assignedPartyId)
          : null,
        isFileAdded: data.isFileAdded,
        files: data.fileId,
        description: isEmptyHtmlContent(data?.description)
          ? ""
          : data.description,
      };
      if (!data.isNew && incidentId !== 0 && data.id) {
        action.actionId = data.id;
      }
      actionListData.push(action);
    });
    const filterActionData = actionListData?.filter(
      (item) => item?.assignedPartyId !== undefined
    );

    const witnessListData = [];
    witnessList.forEach((data) => {
      witnessListData.push({
        employerName: data.employerName,
        witnessName: data.witnessName,
        jobTitle: data.jobTitle,
        statement: data.statement,
        files: `${data.files}`,
      });
    });

    const data = {
      caseId: caseId === 0 ? caseData.caseId : caseId,
      status: INCIDENT_STATUS.SUBMITTED,
      createdBy: parseInt(userId),
      modifiedBy: parseInt(userId),
      incidentId: incidentId,
      fileIds: pdFileIds
        ? [
            ...new Set(
              pdFileIds.filter(
                (id) => id !== null && id !== undefined && id !== ""
              )
            ),
          ]
        : [],
      additionalDetails: formValue.addDetails,
      isWitness: witnessType,
      witness: witnessType ? witnessListData : [],
      actions: filterActionData?.length > 0 ? filterActionData : [],
      propertyDamage: {
        projectId: formValue.projectId ? parseInt(formValue.projectId) : null,
        locationOfDamage: formValue.locationOfDamage,
        whosePropertyId: formValue.whosePropertyId
          ? parseInt(formValue.whosePropertyId)
          : null,
        describeDamage: formValue.describeDamage,
        estimatedCost: formValue.estimatedCost
          ? `${formValue.estimatedCost}`
          : "",
        actionsTaken: formValue.actionsTaken,
        isPoliceReportFiled: formValue.isPoliceReportFiled,
        policeReportNumber: formValue.isPoliceReportFiled
          ? formValue.policeReportNumber
          : "",
        typeOfDamage: findValueMultipleSelect(
          typeOfDamage,
          formValue.typeOfDamage
        ),
        contributingFactors: findValueMultipleSelect(
          propertyDamageContributingFactors,
          formValue.contributingFactors
        ),
      },
    };
    return { propertyDamage: data };
  }

  const submitData = () => {
    const data = mappedData(false);
    if (data) onSubmit(data);
  };

  const saveData = () => {
    const data = mappedData(true);
    data.propertyDamage.status = INCIDENT_STATUS.DRAFT;
    onSubmit(data);
  };

  const searchUsersByProject = (type, text) => {
    searchAllUsers(type, text);
  };

  return (
    <>
      <div className="overidePersonal">
        <Grid item container mt={3} spacing={2}>
          <Grid item lg={4} xs={12} sm={12} md={4}>
            <FormControl fullWidth>
              <FormLabels
                label={intl.get("incident.propertyDamage.projectName")}
              />
              <SearchAutoComplete
                name="propertyDamageProject"
                optionsData={isLoading ? [] : (assetOption ?? [])}
                typeOnchange={(event) => setAssetSearchValue(event.target.value)}
                isKeyValuePair={true}
                value={projectNameValue}
                onChange={(event, value) => onSelectSearchProject(event, value)}
                isLoading={isLoading}
                noOptionsTextMsg={"No project"}
              />
            </FormControl>
          </Grid>
          <Grid item lg={4} xs={12} sm={12} md={4}>
            <InputField
              fullWidth={true}
              type="text"
              isRequired={true}
              label={intl.get("incident.propertyDamage.locationOfDamage")}
              placeholder="Add Location Text Here..."
              id="locationOfDamage"
              value={formValue.locationOfDamage}
              onChange={onChangeField}
              isError={errorState.locationOfDamage}
              errorMsg={
                errorState.locationOfDamage
                  ? "Please enter this required field"
                  : ""
              }
            />
          </Grid>
        </Grid>

        <Grid item container mt={3} spacing={2}>
          <Grid item lg={4} xs={12} sm={12} md={4}>
            <FormLabels
              label={intl.get("incident.propertyDamage.whosePropertyDamaged")}
              isRequired={true}
            />
            <SelectMenu
              name="whosePropertyId"
              listData={sortedWhoseProperty}
              onchangehandler={onChangeSelect}
              value={formValue.whosePropertyId}
              placeholder="Please Select"
              isError={errorState.whosePropertyId}
              errorMsg={
                errorState.whosePropertyId
                  ? "Selection is required for this field"
                  : ""
              }
            />
          </Grid>
          <Grid item lg={4} xs={12} sm={12} md={4}>
            <FormLabels
              label={intl.get("incident.propertyDamage.typeOfDamage")}
              isRequired={true}
            />
            <MultiSelectBox
              placeholder={"Please Select"}
              listData={sortedTypeOfDamage}
              onChange={onChangeSelect}
              value={formValue.typeOfDamage}
              name="typeOfDamage"
              isError={errorState.typeOfDamage}
              errorMessage="Selection is required for this field"
            />
          </Grid>
        </Grid>

        <Grid item container mt={3}>
          <Grid item lg={8} xs={12} sm={12} md={8}>
            <FormControl fullWidth>
              <FormLabels
                label={intl.get("incident.propertyDamage.describeTheDamage")}
                isRequired={true}
              />
              <TextEditor
                placeholder={"Add Description Text Here..."}
                id="describeDamage"
                value={formValue.describeDamage}
                onChange={(value) => {
                  setFormValue((prev) => ({ ...prev, describeDamage: value }));
                  setErrorState((prev) => ({ ...prev, describeDamage: false }));
                }}
                isError={errorState.describeDamage}
                errorMsg={
                  errorState.describeDamage
                    ? "Please enter this required field"
                    : ""
                }
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid item container mt={3} spacing={2}>
          <Grid item lg={4} xs={12} sm={12} md={4}>
            <FormLabels
              label={intl.get("incident.propertyDamage.contributingFactors")}
              isRequired={true}
            />
            <MultiSelectBox
              placeholder={"Please Select"}
              listData={sortedContributingFactors}
              onChange={onChangeSelect}
              value={formValue.contributingFactors}
              name="contributingFactors"
              isError={errorState.contributingFactors}
              errorMessage="Selection is required for this field"
            />
          </Grid>
          <Grid item lg={4} xs={12} sm={12} md={4}>
            <InputField
              fullWidth={true}
              type="text"
              isRequired={false}
              label={intl.get("incident.propertyDamage.estimatedCost")}
              placeholder="$ 0.00"
              id="estimatedCost"
              value={formValue.estimatedCost}
              onChange={onChangeEstimatedCost}
            />
          </Grid>
        </Grid>

        <Grid item container mt={3}>
          <Grid item lg={8} xs={12} sm={12} md={8}>
            <FormControl fullWidth>
              <FormLabels
                label={intl.get("incident.propertyDamage.actionsTaken")}
                isRequired={true}
              />
              <TextEditor
                placeholder={"Add Actions Taken Text Here..."}
                id="actionsTaken"
                value={formValue.actionsTaken}
                onChange={(value) => {
                  setFormValue((prev) => ({ ...prev, actionsTaken: value }));
                  setErrorState((prev) => ({ ...prev, actionsTaken: false }));
                }}
                isError={errorState.actionsTaken}
                errorMsg={
                  errorState.actionsTaken
                    ? "Please enter this required field"
                    : ""
                }
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid className="inputGrid" container mt={3}>
          <Grid item lg={4} xs={12} sm={12} md={4}>
            <FormControl fullWidth>
              <FormLabels
                label={intl.get(
                  "incident.propertyDamage.wasPoliceReportFiled"
                )}
                isRequired={true}
              />
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                className="radioGroup"
              >
                <RadioButton
                  checked={formValue.isPoliceReportFiled === true}
                  value={true}
                  label="Yes"
                  id="isPoliceReportFiledYes"
                  name="policeReport"
                  onChange={(e) =>
                    onChangePoliceReport(JSON.parse(e.target.value))
                  }
                ></RadioButton>
                <RadioButton
                  checked={formValue.isPoliceReportFiled === false}
                  value={false}
                  label="No"
                  id="isPoliceReportFiledNo"
                  name="policeReport"
                  onChange={(e) =>
                    onChangePoliceReport(JSON.parse(e.target.value))
                  }
                ></RadioButton>
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>

        {formValue.isPoliceReportFiled === true && (
          <Grid item container mt={3}>
            <Grid item lg={4} xs={12} sm={12} md={4}>
              <InputField
                fullWidth={true}
                type="text"
                isRequired={true}
                label={intl.get("incident.propertyDamage.policeReportNumber")}
                placeholder="Add Police Report Number Text Here..."
                id="policeReportNumber"
                value={formValue.policeReportNumber}
                onChange={onChangeField}
                isError={errorState.policeReportNumber}
                errorMsg={
                  errorState.policeReportNumber
                    ? "Please enter this required field"
                    : ""
                }
              />
            </Grid>
          </Grid>
        )}

        <Grid className="inputGrid" container mt={3}>
          <Grid item lg={8} xs={12} sm={12} md={8}>
            <FormLabels label={intl.get("incident.propertyDamage.addFiles")} />
            <FormDropZone
              label=""
              paraText1={"Drop the files here ..."}
              paraText2={"Drop Files here, "}
              paraText3={"or Browse"}
              handleFileChange={handlePdFileChange}
              isDoc={true}
              isImage={false}
              allFiles={true}
              isDynamics={true}
              fileType={10}
              imageUrl={pdAddPhoto || ""}
              filess={pdFiless || []}
              deleteImageURL={handleDeletePdFile}
              id="propertyDamageFiles"
              key="propertyDamageFiles"
            />
          </Grid>
        </Grid>

        <Grid className="inputGrid" container mb={2} mt={3}>
          <Grid lg={4} xs={12} sm={12} md={4}>
            <FormLabels label={intl.get("incident.propertyDamage.witness")} />
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              className="radioGroup"
            >
              <RadioButton
                checked={witnessType === true}
                value={true}
                label="Yes"
                onChange={(e) => setWitnessType(JSON.parse(e.target.value))}
                name="witness"
              ></RadioButton>
              <RadioButton
                checked={witnessType === false}
                value={false}
                label="No"
                onChange={(e) => setWitnessType(JSON.parse(e.target.value))}
                name="witness"
              ></RadioButton>
            </RadioGroup>
          </Grid>
        </Grid>

        {witnessType &&
          witnessList.map((singleWitness, index) => (
            <Witness
              key={index}
              keyNo={index + 1}
              singleWitness={singleWitness}
              handleOnChangeWitnessForm={handleOnChangeWitnessForm}
              optionsData={searchOption?.users}
              isErrorWitnessName={singleWitness.isErrorWitnessName}
              isErrorStatement={singleWitness.isErrorStatement}
              errorWitnessNameMsg={singleWitness.errorWitnessNameMsg}
              errorStatementMsg={singleWitness.errorStatementMsg}
              id={singleWitness.id}
              cancelWitnessList={(id) => cancelWitnessList(id)}
              deleteImageURL={(url) =>
                handleDeleteWitnessImage(url, singleWitness)
              }
              witnessFileUpload={(photo) =>
                witnessFileUpload(photo, singleWitness)
              }
            />
          ))}
        {witnessType && (
          <div className="addBox">
            <Button
              varientTextGreen={true}
              disabled={witnessList.length === 4}
              label={intl.get("incident.propertyDamage.addWitness")}
              onClick={handleOnclickWitness}
            />
          </div>
        )}

        {actionList.map((singleAction, index) => (
          <CreateAction
            key={index}
            singleAction={singleAction}
            handleChangeActionDescription={handleChangeCreateActionDesc}
            handleAddAssigneeCta={handleAddAssigneeCta}
            handleUploadFile={handleUploadFileMethod}
            handleCancelCta={handleCreateActionCancelCta}
            incidentId={propertyDamageData?.incidentId}
            isLoading={isLoading}
            optionsData={allUsers?.users ?? []}
            searchUsers={searchUsersByProject}
            isError={singleAction.isError}
            removeActionImage={removeActionImage}
            fileError={fileError}
            isNew={newActionIds.has(singleAction.id)}
            showRequired={false}
            disableAssignee={
              editMode &&
              isDraftforaction !== "1" &&
              !newActionIds.has(singleAction.id)
            }
            isActionLocked={singleAction.status === 3}
            isDescriptionError={singleAction.isErrorDescription}
          />
        ))}
        <div className="addBox">
          <Button
            varientTextGreen={true}
            disabled={actionList.length === 4}
            label={intl.get("incident.case.addAction")}
            onClick={handleOnclickAddAction}
          />
        </div>

        <Grid container mt={3}>
          <Grid item lg={8} xs={12} sm={12} md={8}>
            <FormLabels label={intl.get("incident.case.addAdditinalDetails")} />
            <TextEditor
              placeholder={"Add Additional Details Text Here..."}
              value={formValue.addDetails}
              onChange={(value) =>
                setFormValue((prevFormValue) => ({
                  ...prevFormValue,
                  addDetails: value,
                }))
              }
            />
          </Grid>
        </Grid>

        <Grid container mt={3} spacing={10} alignItems="center">
          <Grid lg={4} xs={12} sm={6} md={4} textAlign="center">
            {(editMode ? isDraft === "1" : true) && (
              <Button
                varientText={true}
                label={intl.get("incident.case.saveAsDraft")}
                onClick={saveData}
              />
            )}
          </Grid>
          <Grid lg={4} xs={12} sm={6} md={4} textAlign="right">
            <Button
              varientContained={true}
              label={intl.get("incident.case.submit")}
              onClick={submitData}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default PropertyDamageForm;
